import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { AffiliateSearchForm } from "@silvertours/front-features";
import { ThemeProvider } from "@emotion/react";
import { Theme } from "@silvertours/front-shared";
var AffiliatePage = function(param) {
    var color = param.color;
    var theme = _object_spread_props(_object_spread({}, Theme.defaultTheme), {
        color: _object_spread_props(_object_spread({}, Theme.defaultTheme.color), {
            primary: color
        })
    });
    return /*#__PURE__*/ _jsx(ThemeProvider, {
        theme: theme,
        children: /*#__PURE__*/ _jsx(AffiliateSearchForm, {
            color: color
        })
    });
};
export { AffiliatePage };
